export default {
  // START:: SET APP THEME
  setAppTheme(state, payload) {
    state.modo_dashboard_theme = payload;
  },
  // END:: SET APP THEME
};
